import { COLORS } from "shared/consts";
import { toRem } from "shared/helpers";
import styled from "styled-components";


export const NewEventWrapper = styled.form`
  min-height: 100%;
  display: flex;
  flex-direction: column;

  @media (width < ${toRem(768)}){
    width: 100vw;
  }
`

type NewEventHeadProps = {
  $isMobile?: boolean;
}
export const NewEventHead = styled.div<NewEventHeadProps>`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: ${props => props.$isMobile ? 'row-reverse' : 'column'};
  gap: ${toRem(12)};
  justify-content: space-between;
  align-items: ${props => props.$isMobile ? 'center' : 'initial'};
`

export const NewEventTitle = styled.h2`
  display: flex;
  gap: ${toRem(12)};
  justify-content: space-between;
  font-weight: 700;
  font-size: ${toRem(22)};
  line-height: ${24 / 22};
  color: ${COLORS.FG.DEFAULT};

  @media (width < ${toRem(768)}){
    font-size: ${toRem(16)};
  }

  button {
    color: ${COLORS.ACCENT.DEFAULT};
  }
`

export const NewEventBody = styled.div`
  padding: ${toRem(16)};
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  
  @media (width >= ${toRem(540)}){
    width: ${toRem(540)};
  }
  @media (width < ${toRem(540)}){
    width: 100vw;
  }
`

type NewEventRowProps = {
  $alignItems?: React.CSSProperties['alignItems'];
}

export const NewEventRow = styled.div<NewEventRowProps>`
  display: flex;
  align-items: ${props => props.$alignItems || 'center'};
  gap: ${toRem(12)};
  margin: ${toRem(6)} 0;
  position: relative;

  &, &>* {
    word-break: break-all;
    max-width: 100%;
    text-overflow: ellipsis;
    &:not(:has(.dropdown-menu)):not(:has(.taggroup)) {
      overflow: hidden;
    }
  }

  >span {
    flex: 0 0 ${toRem(140)};
    font-weight: 500;
    font-size: ${toRem(14)};
    line-height: ${20 / 14};
  }

  @media (width >= ${toRem(540)}){
    .popover__root,
    .dropdown-menu-root {
      min-width: ${toRem(220)};
      max-width: ${toRem(220)};
    }
  }

  .tagitem__label {
    display: flex;
    align-items: center;
    gap: ${toRem(8)};

    img {
      max-width: ${toRem(20)};
      aspect-ratio: 1;
    }
  }

  i {
    color: ${COLORS.FG.MUTED};
  }
`

export const NewEventBorder = styled.div`
  width: 100%;
  height: ${toRem(1)};
  margin: ${toRem(6)} 0;
  background-color: ${COLORS.BORDER.MUTED};
`

type NewEventTextAreaWrapperProps = {
  $height?: string;
}
export const NewEventTextAreaWrapper = styled.div<NewEventTextAreaWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${toRem(4)};
  flex: 1 1 auto;

  textarea {
    border-radius: ${toRem(8)};
    resize: none;
    height: ${props => props.$height || toRem(76)};
    border: ${toRem(2)} solid ${COLORS.BORDER.MUTED};
    padding: ${toRem(8)} ${toRem(12)};
    transition: all 0.3s ease 0s;
  }
`

export const NewEventFooter = styled.div`
  padding: ${toRem(12)} ${toRem(16)};
  border-top: ${toRem(1)} solid ${COLORS.BORDER.SOFT};
  display: flex;
  gap: ${toRem(16)};

  @media (width < ${toRem(768)}){
    display: flex;
    flex-direction: column-reverse;
    gap: ${toRem(12)};
  }
`